export const customWorkflowsList = {
  push: [
    {
      title: "Getting Started",
      description:
        "Guide users through the essential steps to set up and begin using the app",
      type: "getting-started",
    },
  ],
  pull: [
    {
      title: "Getting Started",
      description:
        "Guide users through the essential steps to set up and begin using the app",
      type: "getting-started",
    },
  ],
};

export const WORKFLOW_NAME_MAP = {
  "getting-started": "Getting Started",
};
